module.exports = __webpack_public_path__ + "media/images/jan-4b73d6e1085a95ef539af3abf6b285ad.png";